import ScoreGraph from './ScoreGraph';
import SubPage from '../SubPage';
import PolicySimulator from '../PolicySimulator/PolicySimulator';
import { PAGE_POLICY_SIMULATOR } from '../constants';
import MobileScoreGraph from './mobileClasses/mobileScoreGraph';

class CountryScoreCard {
    // Static instance variable
    static instance = null;

    constructor(data) {
        if (CountryScoreCard.instance) {
            // If an instance already exists, return that instance
            return CountryScoreCard.instance;
        }

        this.data = data;
        this.countryScoreGraph = null;
        this.dropdownElement = $("#selectCountry");
        this.backBtn = document.querySelector('#country-scorecard .top-row .selectContext .backBtn');
        this.policySimBtn = window.innerWidth <= 992 ? document.querySelector('#country-scorecard .mobile-cta .cta_btn') : document.querySelector('#country-scorecard .top-row .right-col .cta_btn');
        this.isPortrait = window.innerWidth <= 992
        // Initialize methods
        this.init();

        // Save the current instance for future access
        CountryScoreCard.instance = this;
    }

    init() {
        if (!this.dropdownElement) {
            console.error("Dropdown element not found!");
            return;
        }

        if (!this.data || !Array.isArray(this.data)) {
            console.error('Invalid data format for population:', this.data);
            return;
        } else {
            this.addCountryDropdown(this.data); // Populate the dropdown
            
            if (window.innerWidth <= 992) {
                this.countryScoreGraph = new MobileScoreGraph(document.querySelector("#chart-area"), this.data);
            } else {
                this.countryScoreGraph = new ScoreGraph(document.querySelector("#chart-area"), this.data);
            }

            this.dropdownElement.dropdown({
                onChange: (value, text, $selectedItem) => {
                    this.countryScoreGraph.updateGraph(value);
                    this.policySimBtn.setAttribute('data-country', value);
                }
            });
        }

        this.policySimBtn.addEventListener('click', () => {
            const country = this.policySimBtn.dataset.country;
            PolicySimulator.getInstance(this.data).policyScoreGraph.updateGraph(country);
            SubPage.getInstance().showPolicySimulatorPage();
            SubPage.setCurrentPage(PAGE_POLICY_SIMULATOR);
            this.isPortrait ? SubPage.handleMobileActiveState(2) : SubPage.handleActiveState(3)
            $('.ui.dropdownPolicy').dropdown('set selected', country);
        });

        this.backBtn.addEventListener('click', () => {
            SubPage.getInstance().hideCountryScoreCardPage();
        });
    }

    updateCountryScore(country) {
        
        this.policySimBtn.setAttribute('data-country', country);
        if (this.countryScoreGraph != null) {
            this.countryScoreGraph.updateGraph(country);
            $('.ui.dropdownCountryScore').dropdown('set selected', country);
        }
    }

    // Dynamically add countries to the dropdown
    addCountryDropdown(data) {
        if (!data || !Array.isArray(data)) {
            console.error('Invalid data format for dropdown population:', data);
            return;
        }

        data.sort((a, b) => {
            if (a.Country.toLowerCase() < b.Country.toLowerCase()) return -1;
            if (a.Country.toLowerCase() > b.Country.toLowerCase()) return 1;
            return 0;
        });

        data.forEach((country) => {
            this.dropdownElement.find('.menu').append(`<div class="item" data-value="${country.Country}"><i class="${country.Code.toLowerCase()} flag"></i>${country.Country}</div>`);
        });
    }

    // Static method to get the singleton instance
    static getInstance(data) {
        if (!CountryScoreCard.instance) {
            CountryScoreCard.instance = new CountryScoreCard(data);
        }
        return CountryScoreCard.instance;
    }
}

export default CountryScoreCard;


